export default __webpack_public_path__ + "static/media/sort-numeric-ascending-default.afbb4527.svg";